// extracted by mini-css-extract-plugin
export var table = "_yp-0";